import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { EmptyList, Loading } from "../../../components";
import { parseSearchParams } from "../../../helpers/clean-object";

import { SearchProductInput } from "../components";
import { useLazyProducts } from "../hooks";
import { ProductsTable } from "../components/product-table";

export const ProductsPriceOnly = () => {
  const [searchParams] = useSearchParams();

  const [limit, _] = useState(25);
  const [search, { data, loading, fetchMore, error }] = useLazyProducts();

  useEffect(() => {
    search({
      variables: {
        limit,
        offset: 0,
        where: {
          ...parseSearchParams(searchParams),
          priceOnly: true,
        },
      },
    });
  }, []);

  useEffect(() => {
    search({
      variables: {
        limit,
        offset: 0,
        where: {
          ...parseSearchParams(searchParams),
          priceOnly: true,
        },
      },
    });
  }, [searchParams]);

  const renderList = () => {
    if (loading) return <Loading />;

    return data?.products?.results?.length &&
      data?.products?.results?.length > 0 ? (
      <ProductsTable
        iData={
          data?.products?.results?.map((product) => ({
            imgUrl: product?.imgUrl,
            product: { name: product?.name, id: product?.id },
            lastPrice: product.lastPrice + " €",
            lastQuantity: product.lastQuantity,
            url: product.url,
          })) || []
        }
      />
    ) : (
      <EmptyList text="Aucun produit 'Price' trouvé" />
    );
  };

  return (
    <>
      <div className="main-container">
        <div className="mb-4">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Produits Prix Uniquement
          </h1>
          <p className="text-sm text-gray-600">
            Liste des produits dont seul le prix est analysé
          </p>
        </div>

        <SearchProductInput {...parseSearchParams(searchParams)} />

        <div className="card mb-2">{renderList()}</div>

        {data?.products?.hasMore ? (
          <div className="flex flex-wrap -mx-4 items-center justify-between">
            <div className="w-full lg:w-1/3 px-4 flex items-center mb-4 lg:mb-0"></div>

            <div className="w-full lg:w-auto px-4 flex items-center justify-center">
              <div
                className="cursor-pointer inline-flex items-center justify-center px-2 h-8 text-xs text-white bg-indigo-500 rounded"
                onClick={() => {
                  fetchMore({
                    variables: {
                      offset: data?.products?.results?.length,
                      limit,
                      where: {
                        ...parseSearchParams(searchParams),
                        priceOnly: true,
                      },
                    },
                  });
                }}
              >
                Charger Plus
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
